// extracted by mini-css-extract-plugin
export default {"root":"x4JHp","tablet":"LSEEA","mobile":"HbCzV","shader":"X8Qxl"};